import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { vasthuUrl } from "./Api";
import { Button, Col, Image, Row } from "react-bootstrap";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { useTranslation } from "react-i18next";

const ConsultantScroll = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const [consultantList, setConsultantList] = useState([]);
  const [loading, setLoading] = useState(false);
  console.log("consultantList", consultantList);

  useEffect(() => {
    setLoading(true);
    try {
      vasthuUrl
        .get(`info/professional/consultantdetails`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          setConsultantList(res.data);
          setLoading(false);
          console.log("consultant_list_data", res.data, token);
        });
    } catch (e) {
      console.log("server error");
      setLoading(false);
    }
  }, []);

  const scrollRef = useRef();

  const scroll = (direction) => {
    if (scrollRef.current) {
      scrollRef.current.scrollBy({
        left: direction === "left" ? -150 : 150,
        behavior: "smooth",
      });
    }
  };

  return (
    <div
      style={{
        border: "1px solid #ffbb33",
        borderLeft: "none",
        borderRight: "none",
        padding: "0.5rem 0px",
      }}
      className="mb-3"
    >
      <Row
        className="d-flex d-md-none"
        style={{
          borderRadius: "5px",
        //   padding: "10px",
        }}
      >
        <h5>{t("CM.CLT.TL")}</h5>
        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            width: "100%",
            fontSize: "14px",
          }}
        >
          <p>{t("CM.HD.CLT.MEN.ASTRO")}&nbsp;&nbsp;|</p>
          <p>&nbsp;{t("CM.HD.CLT.MEN.VASTHUEXP")}&nbsp;&nbsp;|</p>
          <p>&nbsp;{t("CM.HD.CLT.MEN.ART")}</p>
        </div>
      </Row>

      <div
        className="d-none d-md-flex mb-2"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "10px",
        }}
      >
        <span
          style={{
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          {t("CM.CLT.TL")}
        </span>
        <div>
          <span
            style={{
              fontSize: "20px",
              fontWeight: "600",
            }}
          >
            :
          </span>
        </div>
        <div
          style={{
            fontSize: "20px",
            fontWeight: "600",
          }}
        >
          &nbsp;<span>{t("CM.HD.CLT.MEN.ASTRO")}</span>
          &nbsp;|&nbsp;
          <span>{t("CM.HD.CLT.MEN.VASTHUEXP")}</span>&nbsp;|&nbsp;
          <span>{t("CM.HD.CLT.MEN.ART")}</span>
        </div>
      </div>

      <div style={{ position: "relative" }}>
        {/* Left Arrow */}
        <Button
          className="all_btn d-none d-md-block"
          onClick={() => scroll("left")}
          style={{
            position: "absolute",
            left: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1,
            borderRadius: "50%",
            padding: "0.3rem 0.4rem 0.3rem 0.7rem",
          }}
        >
          <MdArrowBackIos />
        </Button>

        <div
          ref={scrollRef}
          style={{
            display: "flex",
            overflowX: "auto",
            WebkitOverflowScrolling: "touch",
            scrollSnapType: "x mandatory",
            gap: "10px",
            cursor: "pointer",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
          }}
          className="consultant_scroll"
          //
        >
          {consultantList.map((i, j) => (
            <div
              key={j}
              style={{
                borderRadius: "5px",
                flex: "0 0 auto",
                width: "100px",
                backgroundColor: "#ffffff",
                scrollSnapAlign: "start",
                border: `2px solid ${
                  i.profstatus === 1 ? "#00cc00" : "#ffbb33"
                }`,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                position: "relative",
              }}
              onClick={() => navigate("consultantdetailspage", { state: i })}
            >
              <div
                style={{
                  position: "absolute",
                  top: "5px",
                  right: "5px",
                  width: "10px",
                  height: "10px",
                  borderRadius: "50%",
                  backgroundColor: i.profstatus === 1 ? "green" : "red",
                  // animation: "grow 0.8s ease-in-out infinite alternate",
                  ...(i.profstatus === 1
                    ? { animation: "grow 0.8s ease-in-out infinite alternate" }
                    : {}),
                }}
              />
              <img
                className="d-block w-100"
                src={i.imgUrl}
                alt={`Slide ${j + 1}`}
                style={{
                  height: "100px",
                  objectFit: "cover",
                  borderRadius: "60px",
                  padding: "1rem",
                }}
              />
              <b style={{ fontSize: "12px" }}>{i.consultantName}</b>
              <b style={{ fontSize: "12px" }}>{i.expYear}&nbsp;Years.</b>
            </div>
          ))}
        </div>
        {/* Right Arrow */}
        <Button
          className="all_btn d-none d-md-block"
          onClick={() => scroll("right")}
          style={{
            position: "absolute",
            right: 0,
            top: "50%",
            transform: "translateY(-50%)",
            zIndex: 1,
            borderRadius: "50%",
            padding: "0.3rem 0.5rem 0.3rem 0.6rem",
          }}
        >
          <MdArrowForwardIos />
        </Button>
      </div>
    </div>
  );
};

export default ConsultantScroll;
